export const BlacklistDomains = [
  'temp-mail.org',
  'pebih.com',
  'yopmail.com',
  'emailondeck.com',
  'tmpbox.net',
  'moak.cc',
  'tmpmail.org',
  'tmpmail.net',
  'tmails.net',
  'disbox.org',
  'moakt.co',
  'moakt.ws',
  'bareed.ws',
  'maildrp.cc',
  'sharklasers.com',
  'grr.la',
  'guerrillamail.info',
  'guerrillamail.com',
  'guerrillamail.net',
  'guerrillamail.org',
  'guerrillamail.biz',
  'pokemail.net',
  'spam.me',
  'firemailbox.club',
  'upived.online',
  'awinceo.com',
  'vusra.com',
  'mailinator.com',
  'inohm.com',
  'nbmbb.com',
  'nestvia.com',
  'evasud.com',
  'jmalaysiaqc.com',
  'firemailbox.club'
];
